var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInserticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_370_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 9V15C11.0003 15.2549 11.0979 15.5 11.2728 15.6854C11.4478 15.8707 11.687 15.9822 11.9414 15.9972C12.1958 16.0121 12.4464 15.9293 12.6418 15.7657C12.8373 15.6021 12.9629 15.3701 12.993 15.117L13 15V9H19C19.5046 8.99985 19.9906 9.19041 20.3605 9.5335C20.7305 9.87659 20.9572 10.3468 20.995 10.85L21 11V20C21.0002 20.5046 20.8096 20.9906 20.4665 21.3606C20.1234 21.7305 19.6532 21.9572 19.15 21.995L19 22H5C4.49542 22.0002 4.00943 21.8096 3.63945 21.4665C3.26947 21.1234 3.04284 20.6532 3.005 20.15L3 20V11C2.99984 10.4954 3.19041 10.0094 3.5335 9.63946C3.87659 9.26948 4.34684 9.04285 4.85 9.005L5 9H11ZM12.884 2.469L16.243 5.827C16.4306 6.01465 16.5361 6.26914 16.5361 6.5345C16.5361 6.79987 16.4306 7.05436 16.243 7.242C16.0554 7.42965 15.8009 7.53506 15.5355 7.53506C15.2701 7.53506 15.0156 7.42965 14.828 7.242L13 5.413V9H11V5.413L9.172 7.242C9.07909 7.33492 8.96879 7.40862 8.8474 7.4589C8.726 7.50918 8.5959 7.53506 8.4645 7.53506C8.33311 7.53506 8.203 7.50918 8.0816 7.4589C7.96021 7.40862 7.84991 7.33492 7.757 7.242C7.66409 7.14909 7.59039 7.03879 7.54011 6.9174C7.48982 6.79601 7.46394 6.6659 7.46394 6.5345C7.46394 6.40311 7.48982 6.273 7.54011 6.15161C7.59039 6.03022 7.66409 5.91992 7.757 5.827L11.117 2.469C11.3514 2.23482 11.6692 2.10327 12.0005 2.10327C12.3318 2.10327 12.6496 2.23482 12.884 2.469Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_370_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInserticon);
export default __webpack_public_path__ + "static/media/insert.icon.eda92e9c3f983cc15d61bc10921069cb.svg";
export { ForwardRef as ReactComponent };